const baseRoutes = {
  start: "/start",
  sign: "/sign",
  finish: "/finish",
};
const homologRoutes = {
    //'backend':'http://192.168.25.106:8087/'
    'backend':'http://localhost:8088/'
}

const prodRoutes = {
    'backend':'https://form2.gntech.med.br:8443/' //TODO ARRUMAR
}

const isProd = window.location.hostname.includes('form2.gntech.med.br');

const AppRoutes = {...baseRoutes, ...(isProd?prodRoutes:homologRoutes)}
export default AppRoutes;
